<template>
<v-layout row wrap>
    <v-flex xs12 md10 lg8>
        <v-autocomplete
                :disabled="readOnly"
                v-model="serviceToAdd"
                :items="notSelectedServices"
                item-value="id"
                item-text="displayTitle"
                :label="$t('services.titleOrCodeFilter.label')"
                :no-data-text="$t('common.autocomplete.noDataText')"
                clearable
                @change="handleAddSelectedService"
        ></v-autocomplete>
    </v-flex>
    <v-flex xs12>
        <table class="v-table theme--light" v-if="selectedServiceRows.length > 0">
            <thead>
            <tr>
                <th v-t="'services.headers.serviceTitle.label'"></th>
                <th v-t="'services.headers.codeTitle.label'"></th>
                <th v-t="'services.headers.clientCodeTitle.label'"></th>
                <th v-t="'services.headers.quantityTitle.label'" width="150"></th>
                <th width="60"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="service in selectedServiceRows" :key="service.id">
                <td><div class="mb-2">{{ service.title }}</div></td>
                <td><div class="mb-2">{{ service.code }}</div></td>
                <td><div class="mb-2">{{ service.externalId | NoEmpty }}</div></td>
                <td>
                    <v-select
                            :disabled="readOnly"
                            :value="service.quantity || 1"
                            :items="quantityOptions"
                            @change="e => { handleQuantityChange(service.id, e) }"
                    ></v-select>
                </td>
                <td>
                    <v-btn flat icon small :disabled="readOnly" @click.prevent="handleRemoveClick(service.id)">
                        <v-icon small>fas fa-trash</v-icon>
                    </v-btn>
                </td>
            </tr>
            </tbody>
        </table>
        <div v-else class="no-services">{{ $t('services.noSelected.label') }}</div>
    </v-flex>
</v-layout>
</template>

<script>

  import _ from 'lodash'
  import NoEmpty from '../Filters/NoEmpty'
  export default {
    name: 'services',
    props: {
      availableServicesById: {
        Type: Array
      },
      availableServices: {
        Type: Array
      },
      selectedServices: {
        Type: Array
      },
      readOnly: {
        Type: Boolean
      }
    },
    filters: { NoEmpty },
    data () {
      return {
        serviceToAdd: null,
        quantityOptions: _.range(1, 51),
      }
    },
    computed: {
      availableVisibleServices () {
        return (this.availableServices || []).filter((service) => !service.hidden)
      },
      selectedServicesById () {
        return _.keyBy(this.selectedServices, 'id')
      },
      notSelectedServices () {
        return this.availableVisibleServices
          .filter((service) => !this.selectedServicesById[service.id])
          .map((service) => ({
            ...service,
            displayTitle: `(${service.code}) ${service.title}`
          }))
      },
      selectedServiceRows () {
        return this.availableVisibleServices
          .filter((service) => !!this.selectedServicesById[service.id])
          .map((service) => ({
            ...service,
            quantity: this.selectedServicesById[service.id].quantity || 1
          }))
      },
    },
    methods: {
      handleAddSelectedService (serviceId) {
        if (!serviceId) {
          return
        }
        this.$emit('addService', serviceId)
        this.serviceToAdd = null
      },
      handleQuantityChange (id, newValue) {
        this.$emit('changeQuantity', {serviceId: id, quantity: newValue})
      },
      handleRemoveClick (id) {
        this.$emit('removeService', id)
      },
    }

  }
</script>

<style>
    .no-services {
      color: rgba(0,0,0,.54);
      margin-top: 8px;
    }
</style>